<template>
  <el-input
    @keyup.enter.native="onSubmitForm"
    class="login-input"
    :placeholder="placeholder"
    :maxlength="type==='verifyCode'?4:null"
    :readonly="readonly"
    :prefix-icon="`icon iconfont_basemanager iconfont `+ getIcon"
    :type="getType"
    :autocomplete="autocomplete"
    v-model="val"
  ></el-input>
</template>

<script>
export default {
  name: "LoginInput",
  props: {
    value: {
      type: String,
      default: ""
    },
    readonly: {
      type: Boolean,
      default: false
    },
    type: {
      type: String
    },
    placeholder: {
      type: String,
      default: ""
    },
    autocomplete: {
      type: String,
      default: "on"
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      this.val = newVal;
    },
    val: function(newVal, oldVal) {
      this.$emit("input", newVal);
    }
  },
  data() {
    return {
      val: this.value
    };
  },
  methods: {
    onSubmitForm() {
      this.$emit("onSubmitForm");
    }
  },
  computed: {
    getIcon() {
      switch (this.type) {
        case "acc":
          return "iconyonghu";
        case "pwd":
          return "iconmima1";
        case "name":
          return "iconedit_light";
      }
    },
    getType() {
      switch (this.type) {
        case "acc":
          return "text";
        case "pwd":
          return "password";
        case "name":
          return "text";
        case "verifyCode":
          return "number";
      }
    }
  }
};
</script>

<style lang="scss">
.login-input {
  // width: 100%;
  .el-input__inner {
    height: 50px;
    background: transparent;
    line-height: 50px;
    padding-left: 70px;
    border: 1px solid #ffffff;
    border-bottom: 1px solid #d5dfe7;
    font-size: 20px;
    color: #3b8cff;
    border-radius: 0;
    font-family: "Microsoft YaHei";
  }

  .el-input__inner:hover {
    border: 1px solid #ffffff;
    border-bottom: 2px solid #3b8cff;
  }

  .el-input__inner:focus {
    border: 1px solid #ffffff;
    border-bottom: 2px solid #3b8cff;
  }

  .el-input__prefix {
    left: 30px;
  }

  .icon {
    font-size: 20px;
    color: #8ab0e6;
    font-weight: bold;
    vertical-align: middle;
  }

  ::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #8ab0e6;
  }

  :-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #8ab0e6;
    opacity: 1;
  }

  ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #8ab0e6;
    opacity: 1;
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #8ab0e6;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/login-input.vue